import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "locality"
const LocalityIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M7.5 14.25H6V12.75H7.5zM12 14.25H10.5V12.75H12zM7.5 10.5H6V9H7.5zM12 10.5H10.5V9H12zM7.5 6.75H6V5.25H7.5zM12 6.75H10.5V5.25H12zM18.75 18.75H17.25V17.25H18.75zM18.75 15H17.25V13.5H18.75z" />
          <path
            fillRule="evenodd"
            d="M14.25 1.5C15.078 1.5 15.75 2.172 15.75 3V9.75H20.25C21.078 9.75 21.75 10.422 21.75 11.25V21C21.75 21.828 21.078 22.5 20.25 22.5H3.75C2.922 22.5 2.25 21.828 2.25 21V3C2.25 2.172 2.922 1.5 3.75 1.5zM3.75 21H5.625V18C5.625 17.172 6.297 16.5 7.125 16.5H10.875C11.703 16.5 12.375 17.172 12.375 18V21H14.25V3H3.75zM15.75 21H20.25V11.25H15.75zM7.125 21H10.875V18H7.125z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default LocalityIcon
